import {
    ChevronRightMedium,
    ExternalLinkMedium
} from '@zoopla-eng/zds-components/icons';

import { MojoLogo } from '@zoopla/assets';

import {
    NotificationLink,
    NotificationTitle,
    NotificationDescription,
    NotificationActionIcon,
    NotificationContent,
    MojoImage
} from './Notification.styles';

import {
    NotificationResult,
    NotificationTypeValues
} from '../../../graphql.generated';
import { NotificationIcon } from '../NotificationIcon/NotificationIcon';

import { EventNames, trackSegmentAndGAEvent, Taxonomy } from '@zoopla/tracking';

type NotificationProps = Omit<NotificationResult, 'createdAt' | 'icon'>;

export const Notification = ({
    title,
    description,
    type,
    link
}: NotificationProps) => {
    const clickNotificationTaxonomy: Taxonomy = {
        page: '/myaccount/my-home/',
        path: '/myaccount/my-home/notifications/',
        brand: 'zoopla',
        activity: 'my_home_notifications',
        section: 'my-home'
    };

    const openInNewTab =
        type === NotificationTypeValues.PlanningApplication ||
        type === NotificationTypeValues.GetMortgage;

    const clickNotificationTracking = () => {
        trackSegmentAndGAEvent(
            EventNames.CLICK_NOTIFICATION,
            {
                eventCategory: 'my home notifications',
                eventAction: 'click',
                eventLabel: type
            },
            `/myaccount/my-home/notifications`,
            clickNotificationTaxonomy
        );
    };
    return (
        <NotificationLink
            href={link}
            onClick={clickNotificationTracking}
            data-testid="notification"
            target={openInNewTab ? '_blank' : ''}
        >
            <NotificationContent>
                <NotificationIcon notificationType={type} />
                <div>
                    <NotificationTitle>{title}</NotificationTitle>
                    <NotificationDescription>
                        {description}
                    </NotificationDescription>
                    {type === NotificationTypeValues.GetMortgage && (
                        <MojoImage src={MojoLogo} alt="Mojo" />
                    )}
                </div>
            </NotificationContent>
            <NotificationActionIcon>
                {openInNewTab ? (
                    <div data-testid="external-link-icon">
                        <ExternalLinkMedium />
                    </div>
                ) : (
                    <div data-testid="chevron-icon">
                        <ChevronRightMedium />
                    </div>
                )}
            </NotificationActionIcon>
        </NotificationLink>
    );
};
